import IztActionSheet from './src/izt-action-sheet'

IztActionSheet.install = Vue => {
  Vue.component(IztActionSheet.name, IztActionSheet)
}

export default IztActionSheet